import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const initialState = {
  selectedTags: [1],
}

export const useGuestStore = create(
  persist(
    set => ({
      ...initialState,
      setSelectedTags: newTag => set({ selectedTags: [parseInt(newTag, 10)] }),
    }),
    {
      name: 'guest',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
